import * as React from 'react';
import Box from '@mui/material/Box';
import { FormControl, InputLabel, MenuItem, Popover, Select, Typography } from '@mui/material';
import "./styles/FiltroEdad.css"

export default function TransitionsPopper(props) {
    // const [open, setOpen] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        // setOpen((previousOpen) => !previousOpen);
    };
    
    const handleClose = () => {
        setAnchorEl(null);
      };

    let Options=["Todos","<7", "7-10", ">10"]
    // const [hba1c, sethba1c] = React.useState(hba1cOptions[2]);

    const handleChange = (event, newValue, activeThumb) => {
      if (newValue.props.value===""){
        props.sethba1c(undefined);  
      }else{
        props.sethba1c(newValue.props.value);
      }
      handleClose();
      
        // return "";
      };

    function displayOption(value){
      if (value==="" || value===undefined){
        return "Todos"
      }
      if (value==="1"){
        return "<7"
      }
      if (value==="2"){
        return "7-10"
      }
      if (value==="3"){
        return ">10"
      }
    }
    
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    
    return (
        <div>
            {/* <span classname="filterbutton">Test</span> */}

            <Typography variant="body1" display="inline" sx={{color:"#ABA9AA"}}>HbA1c: </Typography>
            <Typography className="filterbutton" variant="body1" sx={{color:"#1976d2"}} display="inline" aria-describedby={id} onClick={handleClick}>
              {displayOption(props?.hba1c)}
            </Typography>
            
            <Popover id={id} open={open} anchorEl={anchorEl} onClose={handleClose}>
                {/* {({ TransitionProps }) => ( */}
                    {/* <Fade {...TransitionProps} timeout={350}> */}
                        <Box sx={{ border: 1, p:4,width:"300px", height:"3em",bgcolor: 'background.paper'}}>
                          
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">HbA1c</InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={props.hba1c}
                              label="HbA1c"
                              defaultValue={""}
                              onChange={handleChange}
                            >
                              <MenuItem value={"1"}>{Options[1]}</MenuItem>
                              <MenuItem value={"2"}>{Options[2]}</MenuItem>
                              <MenuItem value={"3"}>{Options[3]}</MenuItem>
                              <MenuItem value={""}>{Options[0]}</MenuItem>
                            </Select>
                          </FormControl>
                        </Box>
                    {/* </Fade> */}
                {/* )} */}
            </Popover>
        </div>
    );
}